import { MINUTE_AS_MILLISECONDS } from 'enum/timeFormat';


export const BASE_AD_URL = 'https://s.st1net.com/ads-iframe-display.php';

export const AD_ZONE_IDS = {
  straight: 206,
  gay: 208,
  trans: 210,
};

export const TRIGGER_DELAY = 2 * MINUTE_AS_MILLISECONDS;
